import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '../components/ProtectedRoute';
import { SmartBooking } from '../pages/SmartBooking';
import { StepTreatment } from '../pages/StepTreatment';
import { StepPatientType } from '../pages/StepPatientType';
import { StepTimeSlot } from '../pages/StepTimeSlot';
import { StepPatientDetails } from '../pages/StepPatientDetails';
import { Confirmation } from '../pages/Confirmation';

export function BookOnlineRoutes() {
  return (
    <Routes>
      <Route
        path="smart-booking"
        element={
          <ProtectedRoute>
            <SmartBooking />
          </ProtectedRoute>
        }
      />
      <Route
        path="step-1"
        element={
          <ProtectedRoute>
            <StepTreatment />
          </ProtectedRoute>
        }
      />
      <Route
        path="step-2"
        element={
          <ProtectedRoute>
            <StepPatientType />
          </ProtectedRoute>
        }
      />
      <Route
        path="step-3"
        element={
          <ProtectedRoute>
            <StepTimeSlot />
          </ProtectedRoute>
        }
      />
      <Route
        path="step-4"
        element={
          <ProtectedRoute>
            <StepPatientDetails />
          </ProtectedRoute>
        }
      />
      <Route
        path="confirmation"
        element={
          <ProtectedRoute>
            <Confirmation />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="step-1" replace />} />
    </Routes>
  );
}
